export enum PermissaoEnum {
    Default = 'default',
    Admin = 'admin',
    Suporte = 'suporte',
    Dev = 'dev',
}
